import { render, staticRenderFns } from "./UserAddOrUpdate.vue?vue&type=template&id=bbc3db8c"
import script from "./UserAddOrUpdate.vue?vue&type=script&lang=js"
export * from "./UserAddOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports